import { useRef } from "react";
import { VideoGuideGroup } from "api/interfaces/managerInterface.interface";
import { HelpGuide } from "hook/useHelpGuideApi";
import VideoGuidesListPresenter from "./VideoGuidesListPresenter";

type Props = {
  item: VideoGuideGroup;
  openYoutube: (guide: HelpGuide) => void;
  openPdfModal: (guide: HelpGuide) => void;
};

export default function VideoGuidesList({
  item,
  openYoutube,
  openPdfModal,
}: Props): JSX.Element {
  const horizontalScrollRef = useRef<any>(null);
  const handleNextButtonClick = (nextType: "prev" | "next") => {
    if (!horizontalScrollRef.current) return;
    if (nextType === "prev") {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft -
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    } else {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft +
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const onClickGuideItem = (guide: HelpGuide) => {
    if (guide.resourceType === "youtube") {
      openYoutube(guide);
      return;
    }
    if (guide.resourceType === "pdf") {
      openPdfModal(guide);
      return;
    }
  };

  const layout = item.layout || "slide";

  const youtubeVideoGuideList = item.videoGuideList.filter(
    (listItem) => listItem.resourceType === "youtube"
  );
  const etcVideoGuideList = item.videoGuideList.filter(
    (listItem) => listItem.resourceType !== "youtube"
  );

  return (
    <VideoGuidesListPresenter
      name={item.name}
      layout={layout as "slide" | "table"}
      handleNextButtonClick={handleNextButtonClick}
      horizontalScrollRef={horizontalScrollRef}
      onClickGuideItem={onClickGuideItem}
      youtubeVideoGuideList={youtubeVideoGuideList}
      etcVideoGuideList={etcVideoGuideList}
    />
  );
}
